// @flow

import { combineReducers } from 'redux';
import { RESET_FILTERS, HYDRATE_FILTERS } from '../../constants';
import type { HydrateFiltersAction, ResetFiltersAction } from '../../actions/filter';
import term from './term';
import range from './range';
import custom from './custom';
import campaign from './campaign';
import type { FilterState } from '../../types';

const filterReducer = combineReducers({
  term,
  range,
  custom,
  campaign,
});

export default (state: any, action: ResetFiltersAction | HydrateFiltersAction): FilterState => {
  switch (action.type) {
    case RESET_FILTERS:
      return filterReducer(undefined, action);
    case HYDRATE_FILTERS:
      return filterReducer({ ...state, ...action.payload }, action);
    default:
      return filterReducer(state, action);
  }
};
